// extracted by mini-css-extract-plugin
export var downArrow = "_9z-0";
export var infoTooltipIcon = "_9z-3";
export var label = "_9z-1";
export var optionCard = "_9z-4";
export var upArrow = "_9z-2";